import { render, staticRenderFns } from "./StandList.vue?vue&type=template&id=0d61a0e7"
import script from "./StandList.vue?vue&type=script&lang=ts"
export * from "./StandList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports